<template>
    <ul class="animate-pulse">
        <li>
            <div class="mb-2 h-5 rounded-sm bg-muted" />
        </li>
        <li>
            <div class="mb-2 h-5 rounded-sm bg-secondary--inverse" />
        </li>
        <li>
            <div class="mb-2 h-5 rounded-sm bg-muted" />
        </li>
        <li>
            <div class="mb-2 h-5 rounded-sm bg-secondary--inverse" />
        </li>
        <li>
            <div class="mb-2 h-5 rounded-sm bg-muted" />
        </li>
    </ul>
</template>
